import { SelectedFilters, StateProvider } from "@appbaseio/reactivesearch"
import classNames from "classnames"
import PropTypes from "prop-types"
import moment from "moment"
import { navigate } from "gatsby"
import React, { useState, useEffect } from "react"
import { FaArrowLeft } from "react-icons/fa"
import { MdClose, MdCheck } from "react-icons/md"
import useSuggestedKeywords from "../../../hooks/use-suggested-keywords"
import FilterFiles from "../../search/filter-files/filter-files"
import styles from "./index.module.scss"
import _ from "lodash"
import { useForm } from "react-form"
import Button from "../../common/button/button"
import { getGroup, updateGroups } from "../../../services/group"
import auth from "../../../services/auth"
import TextField from "../../common/form/text-field/text-field"
import TextArea from "../../common/form/text-area/text-area"
import RenderGroupMedia from "../../common/form/render-group-media/render-group-media"
import ModalWindow from "../../common/modal-window/modal-window"
import AttachMedia from "../../common/attach-media/attach-media"
import FeaturedMediaDisplay from "../../media-output/featured-photos-display/featured-photos-display"
import { MdError } from "react-icons/md"
import MDSpinner from "react-md-spinner"

const SearchGroupEditContent = ({ gid, fnEditState, fnEditFlag }) => {
  const propsWrapper = { props: null }
  const [isOpen, toggleOpen] = useState(false)
  const [addModalOpen, setAddModalOpen] = useState(false)
  const [groups, setGroups] = useState([])
  const [group, setGroup] = useState({})
  const [media, setMedia] = useState([])
  const [submitAttempted, setSubmitAttempted] = useState()
  const [suggestedKeywords, updateKeywords] = useSuggestedKeywords()
  const [lastMultiValue, setLastMultiValue] = useState(null)
  const [activeFilters, setActiveFilters] = useState(null)
  const [showMessage, setShowMessage] = useState(false)
  const [error, setError] = useState()
  const [success, setSuccess] = useState()
  const searchFns = {}
  let _searchState = {}

  const authObj = auth.getAuth()

  const onClearClick = () => {
    // this clears the elastic search query but doesn't properly clear all the inputs
    if (searchFns.clearAll) {
      searchFns.clearAll()
    }
  }

  const onMediaAttached = attachedMedia => {
    console.log("attachedMedia:", attachedMedia)
    var addedMedias = []
    addedMedias.push(attachedMedia)
    const newMed = _.union(media, addedMedias)
    console.log("newMed:", newMed)
    console.log("addedMedias:", addedMedias)
    setMedia(newMed)
    setAddModalOpen(false)
  }

  useEffect(() => {
    if (!gid) {
      console.log("SearchGroupEditContent: no group id to load")
      return
    }
    getGroup(gid).then(group => {
      setGroup(group)
    })
  }, [])

  const getFilterOptionsMarkUp = () => {
    return (
      <div className={classNames(styles?.filter, isOpen ? "" : styles?.close)}>
        <button onClick={() => toggleOpen(!isOpen)} className={styles?.closeBtn}>
          <FaArrowLeft /> Close
        </button>

        <div className={styles?.filterFiles}>
          <FilterFiles
            onClearHandler={onClearClick}
            availableFilters={[
              "type",
              "date",
              "location",
              "copyright",
              "source",
              "people",
            ]}
          />
        </div>
      </div>
    )
  }
  const useContext = React.createContext()
  const { data, editData } = useContext

  const formInstance = useForm({
    debugForm: false,
    onSubmit: values => {
      const groupMedi = group.media
      const NewMedias = _.union(media, groupMedi)
      const updatedObj = {
        ...values,
        media: NewMedias,
      }

      updateGroups(gid, updatedObj).then(
        result => {
          if (result.error) {
            setShowMessage(true)
            setError(result.error)
          } else {
            setShowMessage(true)
            setSuccess()
            setGroups(groups)

            setTimeout(() => {
              fnEditState()
              fnEditFlag(true)
            }, 4000)
          }
        },
        error => {
          setShowMessage(true)
          setError("Error")
        }
      )
    },
    validate: (values, instance) => {
      setShowMessage(false)
      setSubmitAttempted(false)
    },
  })

  const onModalClose = () => {
    setAddModalOpen(false)
  }

  const getEditError = () => {
    if (showMessage) {
      if (error) {
        return (
          <div className={styles?.mediaError}>
            <MdError /> {error}
          </div>
        )
      } else {
        return (
          <div className={styles?.mediaSuccess}>
            <MDSpinner /> {success}
          </div>
        )
      }
    }
  }

  const onCancelClick = () => {
    fnEditState()
    // navigate(`/view-my-group?gid=${currentParamId}`)
  }

  const { Form, meta, pushFieldValue, handleSubmit } = formInstance

  const onSaveClick = event => {
    event.preventDefault()
    handleSubmit(event)
  }

  const onMediaRemove = file => {
    const NewMedias = _.union([], _.pull(media, file))
    setMedia(NewMedias)
  }

  const onMediaAdd = files => {
    var addedMedias = []
    _.map(files, function (file) {
      addedMedias.push(file)
    })

    const NewMedias = _.union(NewMedias, addedMedias)
    setMedia(NewMedias)
  }

  const onAddClick = () => {
    setAddModalOpen(true)
  }

  const getAddMediaModal = () => {
    if (addModalOpen !== true) {
      return null
    }
    return (
      <ModalWindow title="Insert Image" closeHandler={onModalClose}>
        <AttachMedia onMediaAttached={onMediaAttached} mediaType={"Photo"} />
      </ModalWindow>
    )
  }

  // TODO this could maybe be it's own component?
  const getActiveFiltersMarkup = () => {
    return (
      <div className={styles?.keywords}>
        <div className={styles?.selected}>
          <div>
            <Form>
              <div className={styles?.alignbuttons}>
                <div className="textarea">
                  {getEditError()}
                  <TextField
                    label="Title"
                    field="title"
                    type="text"
                    defaultValue={group.title}
                    validate={value => {
                      return !value ? "This is required!" : false
                    }}
                    mandatory
                  />
                  <TextArea
                    label="Description"
                    field="groupDescription"
                    type="text"
                    defaultValue={group.groupDescription}
                    validate={value => {
                      return !value ? "This is required!" : false
                    }}
                    mandatory
                  />

                  <span
                    className="group-createdAt"
                    styles={{
                      fontSize: "small",
                      display: "flex",
                      marginLeft: "15px",
                    }}
                  >
                    <h6>
                      <b>CreatedAt:</b>
                    </h6>
                    <h6>
                      {moment(group.createdAt)
                        .format("MMM DD, YYYY")
                        .toString()}
                    </h6>
                  </span>
                  <br />
                  <br />
                </div>

                <div className={styles?.btncont}>
                  <div>
                    <Button
                      id="add-media"
                      label="Add Media"
                      type="button"
                      prependIcon="MdAdd"
                      btnStyle="primary"
                      btnSize="large"
                      onClick={onAddClick}
                      style={{ width: '100%' }}
                    />
                  </div>

                  <div
                    className="btns"
                    style={{
                      display: "flex",
                      marginTop: "25px",
                      marginLeft: "0px"
                    }}
                  >
                    <span
                    >
                      <Button
                        id="save-group"
                        label="Save"
                        type="button"
                        prependIcon="MdSave"
                        btnStyle="secondary"
                        btnSize="medium"
                        onClick={onSaveClick}
                      />
                    </span>

                    <span
                      style={{
                        marginLeft: "15px",
                      }}
                    >
                      <Button
                        id="cancel-group"
                        label="Cancel"
                        type="button"
                        prependIcon="MdCancel"
                        btnStyle="secondary"
                        btnSize="medium"
                        onClick={onCancelClick}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classNames(styles?.wrapper, isOpen ? styles?.fixed : "")}>
      {/* {getHeaderMarkUp()} */}
      {getAddMediaModal()}
      <div className={styles?.container}>
        {/* {getFilterOptionsMarkUp()} */}
        <div className={styles?.medias}>
          <div>
            {getActiveFiltersMarkup()}
            <div>
              <FeaturedMediaDisplay
                medias={media}
                mediaType="Photo"
                handleRemoveFn={onMediaRemove}
                handleAddFn={onMediaAdd}
              ></FeaturedMediaDisplay>
            </div>
            <div>
              {group.title && (
                <RenderGroupMedia
                  handleRemoveFn={onMediaRemove}
                  handleAddFn={onMediaAdd}
                  medias={media}
                  mediaType="Photo"
                  group={group.title}
                  groupMedia={group.media}
                  id={gid}
                />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
SearchGroupEditContent.propTypes = {
  setEditStateFn: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
}

export default SearchGroupEditContent



